export default __webpack_public_path__ + "static/media/trac_6.18b5f53b.png";